angular.module('amateurPool').component('onswMoreAboutMe', {
  bindings: { 'amateur': '<' },
  templateUrl: '/template/amateurPool.moreAboutMe',
  controller: ['fsk', '$scope', function (fsk, $scope) {
    $scope.fsk = fsk;
  }]
});
